import Vue from 'vue';
import { AxiosResponse, AxiosError } from 'axios';
import { SET_ITEM, SET_ITEMS, ADD_ITEM, UPD_ITEM, REMOVE_ITEM, UPD_LIST_ITEM } from './mutations.type';

import type { CommonReq, CommonNewOrChangeReq, CommonDelReq, CommonResponse } from './types';

// TODO: надо отказаться от этого заголовка т.к. код клиента зашит в токене.
// Вопрос только для суперадмина, надо на бэке проверять не только код клиента но и права суперадмина
export function headers(data, params = {}) {
  return { 
    headers: {
      'X-COMPANY-ID': data.client_id,
    },
    params
  }
}

// Получение всех объектов для отдельного клиента (передается в заголовке X-COMPANY-ID)
export const getModuleItems = async ({commit, rootState}: any, data: CommonReq) => {
  try {
    const resp: AxiosResponse<CommonResponse> = await Vue.axios
      .get(`api/${data.module}`, headers(data, {filter: data.filter}))
    commit(SET_ITEMS, { state: rootState[data.state || data.module], data: resp?.data?.result})
    return resp?.data?.result
  } catch (error) {
    const err = error as AxiosError
    return (err.response?.data as any)?.message || err.message || 'Unknown error'
  }
}

// Получение одного объекта
export const getModuleItem = async ({commit, rootState}: any, data: CommonReq) => {
  try {
    const resp: AxiosResponse<CommonResponse> = await Vue.axios
      .get(`api/${data.module}/${data._id}`, headers(data))
    const state = rootState[data.state || data.module]
    commit(SET_ITEM, { state, data: resp.data?.result, field: data.field})
    return resp.data?.result
  } catch (error) {
    const err = error as AxiosError
    return (err.response?.data as any)?.message || err.message || 'Unknown error'
  }
}

// Создание одного объекта
export const newModuleItem = async ({commit, rootState}: any, data: CommonNewOrChangeReq) => {
  try {
    const resp: AxiosResponse<CommonResponse> = await Vue.axios
      .post(`api/${data.module}`, data.data, headers(data))
    const state = rootState[data.state || data.module]
    const resultData = resp.data?.result
    commit(ADD_ITEM, { state, data: resultData})
    commit(SET_ITEM, { state, data: resultData, field: data.field})
    return resultData
  } catch (error) {
    const err = error as AxiosError
    throw (err.response?.data as any)?.error?.message || err.message || 'Unknown error'
  }
}

// Обновление одного объекта
export const editModuleItem = async ({commit, rootState}: any, data: CommonNewOrChangeReq) => {
  try {
    const resp: AxiosResponse<CommonResponse> = await Vue.axios
      .put(`api/${data.module}/${data._id}`, data.data, headers(data))
    const state = rootState[data.state || data.module]
    const result = resp.data?.result
    commit(UPD_LIST_ITEM, { state, data: result})  // обновляем в списке
    // Если есть функция кастомного обновления данных, применяем ее, а не обычное обновление
    if (data.updFn) data.updFn(state, result); 
    // если в сторе заполнено поле объекта, то его обновляем
    else if (state[data.field || 'item']) commit(UPD_ITEM, { 
      state,
      field: data.field,
      data: result
    })
    return result
  } catch (error) {
    const err = error as AxiosError
    return (err.response?.data as any)?.message || err.message || 'Unknown error'
  }
}

// Удаление одного объекта
export const delModuleItem = async ({commit, rootState}: any, data: CommonDelReq) => {
  try {
    const resp: AxiosResponse<CommonResponse> = await Vue.axios
      .delete(`api/${data.module}/${data._id}`, headers(data))
    commit(REMOVE_ITEM, { state: rootState[data.module], _id: data._id})
    return resp.data?.result
  } catch (error) {
    const err = error as AxiosError
    return (err.response?.data as any)?.message || err.message || 'Unknown error'
  }
}